var React = require('react');

function DividerVertical2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-3.55271368e-13,0 L100,0 L100,100 C33.3333333,88.8892165 -3.55271368e-13,80.5561289 -3.55271368e-13,75.0007371 C-3.55271368e-13,66.6671581 100,33.3328419 100,24.9992629 C100,19.4438711 66.6666667,11.1107835 -3.55271368e-13,0 Z","fill":"#ffffff"}));
}

DividerVertical2.defaultProps = {"width":"100%","height":"100%","version":"1.1","viewbox":"0 0 100 100","preserveAspectRatio":"none"};

module.exports = DividerVertical2;

DividerVertical2.default = DividerVertical2;
